import { useCallback, useEffect, useState } from "react";
import { academyRequest } from "./academyApi";

export type OrganizationLabAnalytics = {
  metricKey: "learning.verified_lab_completion_count";
  definitionVersion: number;
  sourceDomain: "D10";
  availability: "available" | "stale" | "not_projected";
  values: { completed?: number };
  suppressedCells: number;
  minimumCellCount: number;
  freshnessSeconds: number;
  calculatedAt: string | null;
  expiresAt: string | null;
  organizationId: string;
  adoptionAvailable: false;
  utilizationAvailable: false;
  costAvailable: false;
  supportAvailable: false;
  outcomesAvailable: false;
  transactionalAuthority: false;
};

export function useOrganizationLabAnalytics(enabled: boolean) {
  const [data, setData] = useState<OrganizationLabAnalytics>();
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState("");
  const refresh = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    setError("");
    try {
      setData(await academyRequest<OrganizationLabAnalytics>("organization/dashboard/analytics/labs"));
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "Organization Lab analytics are unavailable.");
    } finally {
      setLoading(false);
    }
  }, [enabled]);
  useEffect(() => {
    if (enabled) void refresh();
    else {
      setData(undefined);
      setError("");
      setLoading(false);
    }
  }, [enabled, refresh]);
  return { data, loading, error, refresh };
}
